import {
  Mode,
  Optimism,
  Scroll,
  Ethereum,
  Base,
  Arbitrum
} from '@thirdweb-dev/chains';

export function getNetworkIconUrl(chainId: number) {
  switch (chainId) {
    case Mode.chainId: {
      return Mode.icon.url;
    }
    case Optimism.chainId: {
      return Optimism.icon.url;
    }
    case Scroll.chainId: {
      return Ethereum.icon.url;
    }
    case Ethereum.chainId: {
      return Ethereum.icon.url;
    }
    case Arbitrum.chainId: {
      return Arbitrum.icon.url;
    }
    case Base.chainId: {
      return Base.icon.url;
    }
    default: {
      return '';
    }
  }
}
